import { Injectable, Provider } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse, HTTP_INTERCEPTORS } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { ServerStatusService } from './server-status.service';
import { environment } from '../../environments/environment';

@Injectable()
export class ServerStatusInterceptor implements HttpInterceptor {
  constructor(private serverStatusService: ServerStatusService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      tap(() => {
        // Any successful HTTP activity confirms the server is online
        this.serverStatusService.setOnline();
      }),
      catchError((error: HttpErrorResponse) => {
        if (req.url.startsWith(environment.server_url) && (error.status === 0 || error.status === 502 || error.status === 503 || error.status === 504)) {
          this.serverStatusService.setOffline();
        }
        return throwError(() => error);
      })
    );
  }
}

export const serverStatusInterceptorProvider: Provider = {
  provide: HTTP_INTERCEPTORS,
  useClass: ServerStatusInterceptor,
  multi: true
};
